export default "__VITE_ASSET__711cb69d__"